export const PRICE_SLIDER_STEP = 500;
export const DELIVERY_SLIDER_STEP = 1;
export const MIN_PRICE = 0;
export const MAX_PRICE = 100000;
export const MIN_DELIVERY_DAYS = 0;
export const MAX_DELIVERY_DAYS = 180;

export const DEFAULT_PRICE_RANGE = [MIN_PRICE, MAX_PRICE];
export const DEFAULT_DELIVERY_DAYS = [MIN_DELIVERY_DAYS, MAX_DELIVERY_DAYS];
export const DEBOUNCE_DELAY_MS = 500;
